(() => {
  const menuConfig = {
    'Yeni & Çok Satanlar': {
      key: 'new',
      allLabel: 'Tüm yeni ve çok satanları gör',
      allUrl: '/collections/cok-satanlar',
      columns: [
        ['YENİ GELENLER', [['Yeni Gelenler', '/collections/yeni-gelenler']]],
        ['ÇOK SATANLAR', [['Çok Satanlar', '/collections/cok-satanlar']]],
        ['TÜM KOLEKSİYON', [['Tüm Ürünler', '/collections/tum-urunler']]]
      ],
      mobile: [
        ['Yeni Gelenler', 'Yeni eklenen tasarımlar', '/collections/yeni-gelenler'],
        ['Çok Satanlar', 'En çok tercih edilenler', '/collections/cok-satanlar'],
        ['Tüm Ürünler', 'Koleksiyonun tamamını gör', '/collections/tum-urunler']
      ]
    },
    'Kişiye Özel': {
      key: 'personalized',
      allLabel: 'Tüm kişiye özel ürünleri gör',
      allUrl: '/collections/harfli-fincan',
      columns: [
        ['ÜRÜN FORMATINA GÖRE', [
          ['Harfli Kahve Fincanı', '/collections/harfli-fincan?filter.p.m.bsk.product_format=Kahve%20Fincan%C4%B1'],
          ['Harfli Çay Fincanı', '/collections/harfli-fincan?filter.p.m.bsk.product_format=%C3%87ay%20Fincan%C4%B1'],
          ['Harfli Kupa', '/collections/harfli-kupa-bardak'],
          ['Harfli Sunum Seti', '/collections/harfli-fincan?filter.p.m.bsk.product_format=Sunum%20Seti']
        ]],
        ['MOTİFE GÖRE', [
          ['Melek Kanadı', '/collections/melek-kanadi-koleksiyonu'],
          ['Bahar Dalı', '/collections/bahar-dali-fincan'],
          ['Nazar & Doğa', '/collections/nazar-boncuklu-cay-kahve-fincanlari']
        ]],
        ['KAPASİTEYE GÖRE', [
          ['120 ml Kahve', '/collections/kahve-fincanlari?filter.p.m.bsk.capacity_ml=120'],
          ['150 ml', '/collections/kahve-fincanlari?filter.p.m.bsk.capacity_ml=150'],
          ['160 ml Çay', '/collections/cay-fincanlari?filter.p.m.bsk.capacity_ml=160'],
          ['330 ml Kupa', '/collections/kupalar?filter.p.m.bsk.capacity_ml=330']
        ]]
      ],
      mobile: [
        ['Harfli Kahve Fincanı', '120–150 ml · 24K altın harf', '/collections/harfli-fincan?filter.p.m.bsk.product_format=Kahve%20Fincan%C4%B1'],
        ['Harfli Çay Fincanı', '160–220 ml · kişiye özel', '/collections/harfli-fincan?filter.p.m.bsk.product_format=%C3%87ay%20Fincan%C4%B1'],
        ['Harfli Kupa', '230–330 ml · günlük kullanım', '/collections/harfli-kupa-bardak'],
        ['Harfli Sunum Seti', 'Fincan ve sunum tabağı', '/collections/harfli-fincan?filter.p.m.bsk.product_format=Sunum%20Seti']
      ]
    },
    'Kahve Fincanları': {
      key: 'coffee',
      allLabel: 'Tüm kahve fincanlarını gör',
      allUrl: '/collections/kahve-fincanlari',
      columns: [
        ['KAPASİTEYE GÖRE', [
          ['120 ml · Türk kahvesi boyu', '/collections/kahve-fincanlari?filter.p.m.bsk.capacity_ml=120'],
          ['130 ml', '/collections/kahve-fincanlari?filter.p.m.bsk.capacity_ml=130'],
          ['150 ml', '/collections/kahve-fincanlari?filter.p.m.bsk.capacity_ml=150']
        ]],
        ['KİŞİSELLEŞTİRME', [
          ['Harfli Kahve Fincanı', '/collections/harfli-fincan?filter.p.m.bsk.product_format=Kahve%20Fincan%C4%B1'],
          ['Melek Kanadı', '/collections/melek-kanadi-koleksiyonu'],
          ['Sunum Setleri', '/collections/sunum-setleri-cay-kahve-fincani']
        ]],
        ['MOTİFE GÖRE', [
          ['Bahar Dalı', '/collections/bahar-dali-fincan'],
          ['Nazar & Doğa', '/collections/nazar-boncuklu-cay-kahve-fincanlari'],
          ['Burçlar', '/collections/burc-koleksiyonu'],
          ['Kalpli & Love', '/collections/tum-urunler?filter.p.m.bsk.motifs=Kalpli%20%26%20Love']
        ]]
      ],
      mobile: [
        ['120 ml', 'Türk kahvesi boyu', '/collections/kahve-fincanlari?filter.p.m.bsk.capacity_ml=120'],
        ['130 ml', 'Dengeli günlük boy', '/collections/kahve-fincanlari?filter.p.m.bsk.capacity_ml=130'],
        ['150 ml', 'Daha geniş kahve fincanı', '/collections/kahve-fincanlari?filter.p.m.bsk.capacity_ml=150'],
        ['Sunum Setleri', 'Fincan ve sunum tabağı', '/collections/sunum-setleri-cay-kahve-fincani']
      ]
    },
    'Çay Fincanları': {
      key: 'tea',
      allLabel: 'Tüm çay fincanlarını gör',
      allUrl: '/collections/cay-fincanlari',
      columns: [
        ['KAPASİTEYE GÖRE', [
          ['160 ml', '/collections/cay-fincanlari?filter.p.m.bsk.capacity_ml=160'],
          ['220 ml', '/collections/cay-fincanlari?filter.p.m.bsk.capacity_ml=220']
        ]],
        ['KİŞİSELLEŞTİRME', [
          ['Harfli Çay Fincanı', '/collections/harfli-fincan?filter.p.m.bsk.product_format=%C3%87ay%20Fincan%C4%B1'],
          ['Bahar Dalı', '/collections/bahar-dali-fincan'],
          ['Sunum Setleri', '/collections/sunum-setleri-cay-kahve-fincani']
        ]],
        ['MOTİFE GÖRE', [
          ['Melek Kanadı', '/collections/melek-kanadi-koleksiyonu'],
          ['Nazar & Doğa', '/collections/nazar-boncuklu-cay-kahve-fincanlari']
        ]]
      ],
      mobile: [
        ['160 ml', 'Klasik çay fincanı', '/collections/cay-fincanlari?filter.p.m.bsk.capacity_ml=160'],
        ['220 ml', 'Geniş çay fincanı', '/collections/cay-fincanlari?filter.p.m.bsk.capacity_ml=220'],
        ['Harfli Çay Fincanı', '24K altın baş harf', '/collections/harfli-fincan?filter.p.m.bsk.product_format=%C3%87ay%20Fincan%C4%B1'],
        ['Sunum Setleri', 'Fincan ve sunum tabağı', '/collections/sunum-setleri-cay-kahve-fincani']
      ]
    },
    'Kupalar': {
      key: 'mugs',
      allLabel: 'Tüm kupaları gör',
      allUrl: '/collections/kupalar',
      columns: [
        ['KAPASİTEYE GÖRE', [
          ['230 ml', '/collections/kupalar?filter.p.m.bsk.capacity_ml=230'],
          ['330 ml', '/collections/kupalar?filter.p.m.bsk.capacity_ml=330']
        ]],
        ['KİŞİSELLEŞTİRME', [
          ['Harfli Kupa', '/collections/harfli-kupa-bardak'],
          ['Bahar Dalı', '/collections/bahar-dali-fincan'],
          ['Kupa Sunum Setleri', '/collections/sunum-setleri-cay-kahve-fincani']
        ]],
        ['MOTİFE GÖRE', [
          ['Melek Kanadı', '/collections/melek-kanadi-koleksiyonu'],
          ['Kış & Yeni Yıl', '/collections/yeni-yil-koleksiyonu']
        ]]
      ],
      mobile: [
        ['230 ml', 'Kompakt kupa boyu', '/collections/kupalar?filter.p.m.bsk.capacity_ml=230'],
        ['330 ml', 'Günlük büyük kupa', '/collections/kupalar?filter.p.m.bsk.capacity_ml=330'],
        ['Harfli Kupalar', '24K altın baş harf', '/collections/harfli-kupa-bardak'],
        ['Tüm Kupalar', 'Koleksiyonun tamamı', '/collections/kupalar']
      ]
    },
    'Hediye': {
      key: 'gift',
      allLabel: 'Tüm hediye seçeneklerini gör',
      allUrl: '/pages/hediye',
      notice: {
        label: 'YAKLAŞAN ÖZEL GÜNLER',
        text: 'Hediyeni erkenden seç, kişiselleştirme süresini rahat planla.',
        links: [
          ['Doğum Günü', '/collections/dogum-gunu-hediyeleri'],
          ['Düğün & Nişan', '/collections/dugun-nisan-hediyeleri']
        ]
      },
      columns: [
        ['ÖZEL GÜNE GÖRE', [
          ['Doğum Günü', '/collections/dogum-gunu-hediyeleri'],
          ['Düğün & Nişan', '/collections/dugun-nisan-hediyeleri'],
          ['Yeni Yıl', '/collections/yeni-yil-koleksiyonu'],
          ['Babalar Günü', '/collections/babalar-gunu-hediyeleri-el-yapimi-kisiye-ozel']
        ]],
        ['BÜTÇEYE GÖRE', [
          ['1.000 TL altı', '/collections/tum-urunler?filter.v.price.lte=1000'],
          ['1.000–1.499 TL', '/collections/tum-urunler?filter.v.price.gte=1000&filter.v.price.lte=1499'],
          ['1.500 TL ve üzeri', '/collections/tum-urunler?filter.v.price.gte=1500']
        ]],
        ['HAZIR HEDİYELER', [
          ['Sunum Setleri', '/collections/sunum-setleri-cay-kahve-fincani'],
          ['Kurumsal', '/pages/kurumsal'],
          ['Tüm Çok Satanlar', '/collections/cok-satanlar']
        ]]
      ],
      mobile: [
        ['Doğum Günü', 'Kişiye özel hediye seçenekleri', '/collections/dogum-gunu-hediyeleri'],
        ['Düğün & Nişan', 'Çiftlere özel sunumlar', '/collections/dugun-nisan-hediyeleri'],
        ['Sunum Setleri', 'Hediye vermeye hazır setler', '/collections/sunum-setleri-cay-kahve-fincani'],
        ['Hediye Rehberi', 'Doğru hediyeyi birlikte bulalım', '/pages/hediye']
      ]
    }
  };

  const esc = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[char]);

  const getData = () => {
    const node = document.getElementById('bsk-fidelity-data');
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (error) { return {}; }
  };

  const normalizeLabel = (value) => String(value || '').replace(/\s*\+\s*$/, '').trim();

  function featureMarkup(features) {
    const items = Array.isArray(features) ? features.slice(0, 4) : [];
    while (items.length < 4) items.push(null);
    return items.map((item) => {
      if (!item) return '<span class="bsk-mega__visual bsk-mega__visual--empty"></span>';
      return '<a class="bsk-mega__visual" href="' + esc(item.url) + '">' +
        (item.image ? '<img data-src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy" decoding="async" width="294" height="156">' : '') +
        '<span>' + esc(item.title) + '</span></a>';
    }).join('');
  }

  function hydrateMegaImages(panel) {
    panel.querySelectorAll('img[data-src]').forEach((image) => {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    });
  }

  function megaMarkup(config, featureData) {
    const notice = config.notice
      ? '<div class="bsk-mega__notice"><span class="bsk-mega__notice-label">' + esc(config.notice.label) + '</span><span class="bsk-mega__notice-text">' + esc(config.notice.text) + '</span><nav class="bsk-mega__notice-links" aria-label="Yaklaşan özel günler">' + config.notice.links.map(([label, url]) => '<a href="' + esc(url) + '">' + esc(label) + '</a>').join('<span aria-hidden="true">·</span>') + '</nav></div>'
      : '';
    const columns = config.columns.map(([heading, links]) => '<div class="bsk-mega__column"><h3>' + esc(heading) + '</h3>' + links.map(([label, url]) => '<a href="' + esc(url) + '">' + esc(label) + '</a>').join('') + '</div>').join('');
    return notice + '<div class="bsk-mega__body"><div class="bsk-mega__columns">' + columns + '<div class="bsk-mega__visuals">' + featureMarkup(featureData) + '</div></div></div><a class="bsk-mega__cta" href="' + esc(config.allUrl) + '">' + esc(config.allLabel) + '</a>';
  }

  function createScrim() {
    let scrim = document.querySelector('.bsk-mega-scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'bsk-mega-scrim';
      const header = document.querySelector('.bsk-uheader');
      header?.insertAdjacentElement('afterend', scrim);
    }
    return scrim;
  }

  function initializeDesktopMenus(data) {
    const header = document.querySelector('.bsk-uheader');
    const nav = header?.querySelector('.bsk-uheader__desktop-nav');
    if (!header || !nav || nav.dataset.bskFidelityReady) return;
    nav.dataset.bskFidelityReady = 'true';
    const scrim = createScrim();

    nav.querySelectorAll('.bsk-uheader__nav-item').forEach((item) => {
      const anchor = item.querySelector(':scope > a');
      const label = normalizeLabel(anchor?.textContent);
      const config = menuConfig[label];
      if (!anchor || !config) return;
      item.querySelector('.bsk-uheader__dropdown')?.setAttribute('hidden', '');
      item.querySelector(':scope > .bsk-mega')?.remove();
      anchor.setAttribute('aria-haspopup', 'true');
      anchor.setAttribute('aria-expanded', 'false');
      const panel = document.createElement('div');
      panel.className = 'bsk-mega bsk-mega--' + config.key;
      panel.id = 'BskMega-' + config.key;
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-label', label + ' menüsü');
      const featureData = data.features?.[config.key] || (config.key === 'new' ? data.features?.coffee : undefined);
      panel.innerHTML = megaMarkup(config, featureData);
      item.appendChild(panel);
      anchor.setAttribute('aria-controls', panel.id);

      const open = () => {
        hydrateMegaImages(panel);
        nav.querySelectorAll('.bsk-uheader__nav-item.bsk-mega-active').forEach((activeItem) => {
          if (activeItem === item) return;
          activeItem.classList.remove('bsk-mega-active');
          activeItem.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
        });
        item.classList.add('bsk-mega-active');
        anchor.setAttribute('aria-expanded', 'true');
        header.classList.add('bsk-mega-open');
        scrim?.classList.add('bsk-mega-scrim--open');
      };
      const close = () => {
        window.setTimeout(() => {
          if (item.matches(':hover') || item.contains(document.activeElement)) return;
          item.classList.remove('bsk-mega-active');
          anchor.setAttribute('aria-expanded', 'false');
          if (nav.querySelector('.bsk-uheader__nav-item.bsk-mega-active')) return;
          header.classList.remove('bsk-mega-open');
          scrim?.classList.remove('bsk-mega-scrim--open');
        }, 20);
      };
      item.addEventListener('pointerenter', open);
      item.addEventListener('pointerleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', close);
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        item.classList.remove('bsk-mega-active');
        anchor.setAttribute('aria-expanded', 'false');
        header.classList.remove('bsk-mega-open');
        scrim?.classList.remove('bsk-mega-scrim--open');
        anchor.focus();
      });
    });
  }

  function submenuMarkup(label, config) {
    return '<section class="bsk-mobile-submenu" data-bsk-mobile-submenu="' + esc(config.key) + '" hidden><header class="bsk-mobile-submenu__head"><button type="button" data-bsk-mobile-back aria-label="Geri">←</button><strong>' + esc(label) + '</strong><button type="button" data-bsk-mobile-close aria-label="Menüyü kapat">×</button></header><a class="bsk-mobile-submenu__all" href="' + esc(config.allUrl) + '"><span>' + esc(config.allLabel) + '</span><span>→</span></a><div>' + config.mobile.map(([name, subtitle, url]) => '<a class="bsk-mobile-submenu__row" href="' + esc(url) + '"><strong>' + esc(name) + '</strong><small>' + esc(subtitle) + '</small></a>').join('') + '</div></section>';
  }

  function initializeMobileMenu() {
    const details = document.querySelector('.bsk-uheader__mobile-menu');
    const panel = details?.querySelector('.bsk-uheader__mobile-panel');
    const nav = panel?.querySelector('.bsk-uheader__mobile-nav');
    if (!details || !panel || !nav || panel.dataset.bskFidelityReady) return;
    panel.dataset.bskFidelityReady = 'true';

    const order = [
      ['Yeni & Çok Satanlar', '/collections/cok-satanlar'],
      ['Kişiye Özel', '/collections/harfli-fincan'],
      ['Kahve Fincanları', '/collections/kahve-fincanlari'],
      ['Çay Fincanları', '/collections/cay-fincanlari'],
      ['Kupalar', '/collections/kupalar'],
      ['Hediye', '/pages/hediye'],
      ['Kurumsal', '/pages/kurumsal']
    ];

    nav.innerHTML = order.map(([label, url]) => {
      const config = menuConfig[label];
      if (!config) return '<a class="bsk-mobile-nav-link" href="' + esc(url) + '"><span>' + esc(label) + '</span><span class="bsk-mobile-nav-arrow">→</span></a>';
      const featured = label === 'Kişiye Özel';
      return '<button class="bsk-mobile-nav-button' + (featured ? ' bsk-mobile-nav-button--featured' : '') + '" type="button" data-bsk-mobile-open="' + esc(config.key) + '">' + (featured ? '<span class="bsk-mobile-nav-icon">A</span>' : '') + '<span class="bsk-mobile-nav-button__copy"><strong>' + esc(label) + '</strong>' + (featured ? '<small>Harfini seç, sana özel üretelim</small>' : '') + '</span><span class="bsk-mobile-nav-arrow">›</span></button>';
    }).join('');

    panel.querySelectorAll(':scope > .bsk-mobile-submenu').forEach((submenu) => submenu.remove());
    Object.entries(menuConfig).forEach(([label, config]) => panel.insertAdjacentHTML('beforeend', submenuMarkup(label, config)));

    const closeDrawer = () => {
      details.open = false;
      panel.querySelectorAll('.bsk-mobile-submenu--open').forEach((submenu) => {
        submenu.classList.remove('bsk-mobile-submenu--open');
        window.setTimeout(() => { submenu.hidden = true; }, 210);
      });
    };

    panel.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-bsk-mobile-open]');
      const backButton = event.target.closest('[data-bsk-mobile-back]');
      const closeButton = event.target.closest('[data-bsk-mobile-close]');
      if (openButton) {
        const submenu = panel.querySelector('[data-bsk-mobile-submenu="' + CSS.escape(openButton.dataset.bskMobileOpen) + '"]');
        if (!submenu) return;
        submenu.hidden = false;
        requestAnimationFrame(() => submenu.classList.add('bsk-mobile-submenu--open'));
      } else if (backButton) {
        const submenu = backButton.closest('.bsk-mobile-submenu');
        submenu?.classList.remove('bsk-mobile-submenu--open');
        window.setTimeout(() => { if (submenu) submenu.hidden = true; }, 210);
      } else if (closeButton) {
        closeDrawer();
      }
    });
  }

  function applyBackground(selector, url) {
    if (!url) return;
    const element = document.querySelector(selector);
    if (!element) return;
    if (element.querySelector('img, picture')) {
      element.style.removeProperty('background-image');
      element.classList.remove('bsk-has-real-image');
      return;
    }
    element.style.backgroundImage = `url("${String(url).replace(/"/g, '%22')}")`;
    element.classList.add('bsk-has-real-image');
  }

  function initializeHomeImages(data) {
    const images = data.homeImages || {};
    (images.formats || []).forEach((url, index) => applyBackground(`.bsk-format-grid > a:nth-child(${index + 1}) .bsk-pattern`, url));
    (images.steps || []).forEach((url, index) => applyBackground(`.bsk-steps > div:nth-of-type(${index + 1}) .bsk-pattern`, url));
    [['.bsk-workshop__image', images.workshop], ['.bsk-gift-image', images.gift]].forEach(([selector, url]) => {
      const element = document.querySelector(selector);
      if (!element) return;

      // Theme Editor selections and Liquid fallbacks render a real image.
      // Keep that image authoritative instead of replacing it at runtime.
      if (element.querySelector('img')) {
        element.style.removeProperty('background-image');
        element.classList.remove('bsk-runtime-image');
        return;
      }

      if (!url) return;
      element.style.backgroundImage = `url("${String(url).replace(/"/g, '%22')}")`;
      element.classList.add('bsk-runtime-image');
    });
  }

  function initialize() {
    const data = getData();
    initializeDesktopMenus(data);
    initializeMobileMenu();
    initializeHomeImages(data);
    document.documentElement.classList.add('bsk-fidelity-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();

  document.addEventListener('shopify:section:load', initialize);
})();

